export default __webpack_public_path__ + "static/media/simple_muted.a0d2b8e2.svg";